import dayjs from "dayjs";

function* getMonthsIterator(dateString: string) {
  let date = dayjs(dateString);
  while (true) {
    yield date.format("YYYY-MM");
    date = date.add(1, "month");
  }
}

const NOT_ENOUGH_DATA = "not-enough-data";
const STALE_DATA = "stale-data";
const GAPS_IN_DATA = "gaps-in-data";

export function validateAccountingPeriods(extractedMonths: string[]): { errors: string[] } {
  const MAX_STALE_MONTHS_COUNT = 3;
  const REQUIRED_MONTHS_LENGTH = 24;

  if (!extractedMonths.length) {
    return { errors: [NOT_ENOUGH_DATA] };
  }

  const errors = [];

  if (extractedMonths.length < REQUIRED_MONTHS_LENGTH) {
    errors.push(NOT_ENOUGH_DATA);
  }

  extractedMonths.sort();
  const lastAvailableMonth = dayjs(extractedMonths.at(-1) as string);
  const now = dayjs();

  if (now.diff(lastAvailableMonth, "month") > MAX_STALE_MONTHS_COUNT) {
    errors.push(STALE_DATA);
  }

  const monthsIter = getMonthsIterator(extractedMonths[0]);
  for (const currentMonth of extractedMonths) {
    const { value: expectedMonth } = monthsIter.next();
    if (currentMonth !== expectedMonth) {
      errors.push(GAPS_IN_DATA);
      break;
    }
  }

  return { errors };
}
